import React from 'react'
import t from '../../service/translate.service'
import './index.css'
import { isAndroid, isIOS } from '../../service/deviceDetection.service';

const DownloadAppModal = () => {
  return (
    <div className="download-app-modal-wrapper">
      <div>
        <div className="logo">
          <img src='https://serviceportal-uat.grandcityproperty.de/static/media/GCP_Logo.png' alt={t.LOADING} />
        </div>
        <h2>{t.CONTRACT_SIGN_POP_UP_DOWNLOAD_APP_HEAD}</h2>
        <p>{t.CONTRACT_SIGN_POP_UP_DOWNLOAD_APP_TEXT}</p>
        <div className='download-buttons'>
          {isAndroid && (
            <a href="https://play.google.com/store/apps/details?id=com.gcpapp">
              <img
                src="https://serviceportal-uat.grandcityproperty.de/static/media/androidBtn.png"
                alt="Download Android App"
              />
            </a>
          )}
          {isIOS && (
            <a href="https://apps.apple.com/us/app/gcp-service-app/id1190303260">
              <img
                src="https://serviceportal-uat.grandcityproperty.de/static/media/iosBtn.png"
                alt="Download iOS App"
              />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default DownloadAppModal